import { VisibilityBooking } from '@/common/apis/dtos';
import { Typography } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Box, Stack } from '@mui/material';
import { RelatedBookingsItems } from './RelatedBookingsItems';
import { EmptyContent } from '@/common/components/empty-content/EmptyContent';

export interface RelatedBookingsProps {
  booking: VisibilityBooking;
}

export const RelatedBookings = ({ booking }: RelatedBookingsProps) => {
  const translate = useTranslation();

  return (
    <Stack
      spacing={3}
      padding={1}
      data-testid="cargo-item-details-tab"
      sx={{
        marginBottom: (theme) => theme.spacing(2)
      }}
    >
      <Stack spacing={1}>
        <Typography
          variant="display300">{`${translate('Related Bookings for')} ${booking.customerBookingNumber}`}</Typography>
        <Typography variant="body100">
          {translate('A list of other bookings associated with this record based on primary reference number.')}
        </Typography>
      </Stack>
      {booking.relatedBookings && booking.relatedBookings.length > 0 ? (
        <Box>
          <RelatedBookingsItems
            items={booking.relatedBookings}
          />
        </Box>
      ) : (
        <EmptyContent
          title={translate('No Related Bookings are available')}
          bodyText={translate('If any are detected in the future they will display in this tab.')}
        />
      )}
    </Stack>
  );
};
